module.exports = __webpack_public_path__ + "static/media/icon_qiyehaomashensu.3b68df20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_qiyehaomashensu.svg
// module id = 220
// module chunks = 0